import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users, TrendingUp, BookOpen, FileText, ArrowUpRight } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)); }, []);
  if (!stats) return <div className="p-10">Loading...</div>;

  const cards = [
    { label: "Total Leads", value: stats.total_leads, icon: Users, color: "sky" },
    { label: "New Leads", value: stats.new_leads, icon: TrendingUp, color: "orange" },
    { label: "Total Courses", value: stats.total_courses, icon: BookOpen, color: "emerald" },
    { label: "Total Blogs", value: stats.total_blogs, icon: FileText, color: "violet" },
  ];

  const sourceBreakdown = [
    { label: "Contact Form", value: stats.contact_leads },
    { label: "Course Enquiry", value: stats.course_leads },
    { label: "Chatbot", value: stats.chatbot_leads },
    { label: "Converted", value: stats.converted },
  ];

  return (
    <div className="p-8">
      <h1 className="font-display font-black text-3xl tracking-tight" data-testid="admin-dashboard-title">Dashboard</h1>
      <p className="text-neutral-500 mt-1">Overview of your leads and content</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {cards.map((c, i) => (
          <div key={i} className="bg-white rounded-2xl p-6 border border-neutral-200" data-testid={`stat-card-${i}`}>
            <div className={`w-10 h-10 rounded-xl bg-${c.color}-100 flex items-center justify-center mb-3`}>
              <c.icon className={`w-5 h-5 text-${c.color}-600`} />
            </div>
            <div className="text-3xl font-display font-black">{c.value}</div>
            <div className="text-xs text-neutral-500 mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mt-8">
        <div className="lg:col-span-2 bg-white rounded-2xl p-6 border border-neutral-200">
          <h3 className="font-display font-bold mb-4">Recent Leads</h3>
          <div className="space-y-3">
            {stats.recent_leads.map((l) => (
              <div key={l.id} className="flex items-center justify-between p-3 rounded-xl bg-neutral-50" data-testid={`recent-lead-${l.id}`}>
                <div>
                  <div className="font-semibold text-sm">{l.name}</div>
                  <div className="text-xs text-neutral-500">{l.phone} • {l.source}</div>
                </div>
                <div className="text-xs">
                  <span className="px-2 py-1 rounded-full bg-sky-100 text-sky-700 font-semibold">{l.status}</span>
                </div>
              </div>
            ))}
            {stats.recent_leads.length === 0 && <div className="text-sm text-neutral-500">No leads yet.</div>}
          </div>
        </div>
        <div className="bg-white rounded-2xl p-6 border border-neutral-200">
          <h3 className="font-display font-bold mb-4">Lead Sources</h3>
          <div className="space-y-3">
            {sourceBreakdown.map((s, i) => (
              <div key={i} className="flex justify-between items-center text-sm">
                <span className="text-neutral-600">{s.label}</span>
                <span className="font-display font-bold">{s.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
